import { Button, ModalBody, ModalFooter, ModalHeader, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SubmitFormBtn } from '../Buttons/SubmitFormBtn';
import { BaseModal } from './BaseModal';

interface IUserProfileHaveMembers {
  isOpen: boolean;
  onClose: VoidFunction;
  onConfirm: VoidFunction;
}

export const UserProfileHaveMembers = (props: IUserProfileHaveMembers) => {
  const { t } = useTranslation();
  return (
    <BaseModal {...props}>
      <>
        <ModalHeader>{t('modal.error.delete.profile.failed.by.members.caption')}</ModalHeader>

        <ModalBody>
          <Text>{t('modal.error.delete.profile.failed.by.members.text')}</Text>
        </ModalBody>

        <ModalFooter>
          <VStack spacing={4}>
            <SubmitFormBtn size='lg' minH={14} onClick={props?.onConfirm}>
              {t('modal.error.delete.profile.failed.by.members.confirm.btn')}
            </SubmitFormBtn>
            <Button variant='linkUnderlinePrimary' size='sm' onClick={props?.onClose}>
              {t('cancel')}
            </Button>
          </VStack>
        </ModalFooter>
      </>
    </BaseModal>
  );
};
